<template>
    <v-color-picker
        :value="value"
        v-on:input="$emit('input', $event.hex ? $event.hex : $event)"
        hide-canvas
        hide-inputs
        hide-mode-switch
        show-swatches
        :width="field.width"
        class="pb-6 background-2"
        flat
    ></v-color-picker>
</template>

<script>
export default {
    name: 'yello-color-picker',
    props: [
        'value', 
        'field',
    ],
    data() {
        return {
        }
	},
}
</script>

<style>

</style>